import { stringExistsIn } from 'MODULES/validations';
import { checkNested } from 'MODULES/checkNested';

export const isSlugInRealEstateCategory = categorySlug => stringExistsIn('real-estate', checkNested(categorySlug, 'en'));
